import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { assertBetaAccess } from "@/lib/beta-access";
import { resolveCompany } from "@/lib/company-access";
import { getOwnerUsage } from "@/lib/usage.server";

export const getBillingStatus = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    await assertBetaAccess(context.supabase, context.userId);
    const access = await resolveCompany(context.supabase, context.userId);
    // Shared credit pool: usage is summed across all of the user's twins.
    const usage = await getOwnerUsage(context.supabase, context.userId);
    return {
      plan: usage.plan,
      used: usage.used,
      limit: usage.limit,
      remaining: usage.remaining,
      resetsAt: usage.resetsAt,
      twinCount: usage.twinCount,
      companyId: access?.id ?? null,
    };
  });
